<template>
  <v-container
    fluid
    fill-height
    pa-0
    :class="[$style.root]"
    :style="{
      overflow: 'auto',
      maxHeight: `${tableHeight}px`
    }"
  >
    <v-row class="fill-height" no-gutters>
      <SmsMessageForm />
    </v-row>
  </v-container>
</template>

<script>
import SmsMessageForm from './SmsMessageForm.vue'
import inputTableHeight from '@/mixins/inputTableHeight'

export default {
  name: 'SmsMessageContainer',

  components: { SmsMessageForm },

  mixins: [inputTableHeight(334)],

  computed: {}
}
</script>

<style lang="scss" module>
.root {
  height: calc(100vh - 334px);
}
</style>
